/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {format, parse} from 'date-fns';

export const localTimeToDatabaseTime = (input?: string): string | undefined => {
  if (!input) return undefined;
  const localTime = parse(input, 'yyyy-MM-dd HH:mm:ss', new Date());
  const databaseTime = localTime.toISOString(); // ie utc
  return databaseTime;
};

export const databaseTimeToLocalTime = (input?: Date | string): string | undefined => {
  if (!input) return undefined;
  const databaseTime = typeof input === 'string' ? new Date(input) : input;
  return format(databaseTime, 'yyyy-MM-dd HH:mm:ss');
};
